import React, {Fragment} from "react";
import mus_entry from "./mus_entry";
import MusCatEntry from "./MusCatEntry";
import MusCategories from "./MusCategories";


const categories_serializer = (categories) => {
    const categ_serializer = {}
    categories.map((item) => {
        const data = {
            id: item.id,
            title: item.title,
            client_cost: item.client_cost,
            estro_cost: item.estro_cost,
        }

        if (item.categorie in categ_serializer) {
            categ_serializer[item.categorie].push(data)
        } else {
            categ_serializer[item.categorie] = [data];
        }
    })
    return categ_serializer;
}



const AdditionalMusicianItem = ({musician, index, handlePopup, changeHandler}) => {
    let categories_data = {}

    if (musician.categories.length > 0) {
        categories_data = categories_serializer(musician.categories);
    }

    return (<>
        { mus_entry(musician, index, handlePopup) }

        { Object.keys(categories_data).length > 0
            ?(<>
                {Object.keys(categories_data).map((key, key_index) => (
                    <Fragment key={"entry_" + key_index} >
                        <MusCategories categories_name={key} />
                        <MusCatEntry
                            data={categories_data[key]}
                            changeHandler={changeHandler}
                            musician_id={musician.musician_id}
                        />
                    </Fragment>
                ))}
            </>)
            : null
        }
    </>)
}


export default AdditionalMusicianItem;
